////// <reference path="../../reference.ts" />
import {utils} from '../../utils/index'
import {ItemCore} from '../../_domain/item-core'

class ItemLayout extends ItemCore {

  constructor(config) {
    super(config);
    this.idx = config.idx;
    this.smartCrop = config.smartCrop;
    this.createdBy = config.createdBy;
    this._offset = {};
    this._group = {};

    this.uniqueId = utils.getUUID();
    if (!utils.isSemiNative()) {
      this.resize(1);
    }
  }

  getViewProps(config) {

    return _.merge({
      className: 'image',
      key: this.key,
      idx: this.idx,
      photoId: this.photoId,
      id: this.id,
      hash: this.id,
      html: this.html,
      type: this.type,
      url: this.url,
      alt: this.alt,
      linkUrl: this.linkUrl,
      linkOpenType: this.linkOpenType,
      originalsUrl: this.getOriginalsUrl(),
      title: this.title,
      fileName: this.fileName,
      description: this.description,
      full_url: this.full_url,
      download_url: this.download_url,
      square_url: this.square_url,
      pixel_url: this.pixel_url,
      resized_url: this.resized_url,
      thumbnail_url: this.thumbnail_url,
      cubeImages: this.cubeImages,
      cubeType: this.cubeType,
      cubeRatio: this.cubeRatio,
      offset: this._offset,
      style: this.style,
      isDemo: this.isDemo,
      videoUrl: this.videoUrl,
      isExternalVideo: this.isExternalVideo,
      scroll: config.scroll,
      visible: config.visible,
      styleParams: config.styleParams,
      actions: config.actions,
      currentIdx: config.currentIdx
    }, config);
    
  }

  pinToCorner(cornerName) {

    var isTop = cornerName.indexOf('top') >= 0;
    var isLeft = cornerName.indexOf('left') >= 0;

    this.style.top = isTop ? 0 : 'auto';
    this.style.bottom = isTop ? 'auto' : 0;
    this.style.left = isLeft ? 0 : 'auto';
    this.style.right = isLeft ? 'auto' : 0;

    this.pin = cornerName;
    this.isPinnedTop = isTop;
    this.isPinnedLeft = isLeft;

  }

  setPosition(position) {
    this.style.position = position;
  }

  getPosition(pos) {
    return (parseInt(pos, 10) >= 0 ? pos : 'auto');
  }


  get hash() {
    return this.id;
  }

  get seed() {
    return utils.hashToInt(this.url);
  }

  get key() {
    if (!this._key) {
      this._key = (this.dto.key || this.id || this.dto.url || 'no_key_found').replace(/\W/g, '');
    }
    return this._key;
  }

  get demoTitle() {
    return 'I am a title, only a sample title but still a title. ';
  }

  get demoDescription() {
    return 'I am a description, the best description ever! Here is some lorem ipsum for you: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.';
  }

  get demoExif() {
    return {"GPSVersionID":"2.2.0.0","GPSAltitudeRef":"1.8","GPSAltitude":"0","Make":"LG Electronics","Model":"LG-H815L","Orientation":"right-top","XResolution":"72","YResolution":"72","ResolutionUnit":"2","Software":"Picasa","DateTime":"2016:04:17 07:19:25","YCbCrPositioning":"1","ExposureTime":"0.041666666666666664","FNumber":"1.8","ExifIFDPointer":"214","ExposureProgram":"Undefined","GPSInfoIFDPointer":"1262","PhotographicSensitivity":"200","ExifVersion":"0220","DateTimeOriginal":"2016:04:17 07:19:25","DateTimeDigitized":"2016:04:17 07:19:25","ComponentsConfiguration":"YCbCr","ShutterSpeedValue":"4.585","ApertureValue":"1.69","BrightnessValue":"-0.88","ExposureBias":"0","MeteringMode":"CenterWeightedAverage","Flash":"Flash did not fire, compulsory flash mode","FocalLength":"4.42","UserComment":"32,32,32,70,77,49,32,32,32,70,67,48,48,48,48,48,48,48,48,48,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0","SubSecTime":"802528","SubSecTimeOriginal":"802528","SubSecTimeDigitized":"802528","FlashpixVersion":"0100","ColorSpace":"1","PixelXDimension":"5312","PixelYDimension":"2988","InteroperabilityIFDPointer":"1320","SensingMethod":"Undefined","SceneType":"Directly photographed","ExposureMode":"0","WhiteBalance":"Auto white balance","DigitalZoomRatio":"1","SceneCaptureType":"Standard","ImageUniqueID":"36f6e92221e27c830000000000000000"};
  }

  get isImage() {
    return this.type == 'image';
  }

  get isImportant() {
    return !!(this.dto.i);
  }

  get videoUrl() {
    return this.metadata.videoUrl;
  }

  get isExternalVideo() {
    return this.metadata.isExternal;
  }

  get orderIndex() {
    return this.dto.orderIndex || this.dto.o;
  }

  get top() {
    return this.getPosition(this.style.top);
  }

  get left() {
    return this.getPosition(this.style.left);
  }

  get right() {
    return this.getPosition(this.style.right);
  }

  get bottom() {
    return this.getPosition(this.style.bottom);
  }

  set group(group) {
    _.merge(this._group, group);
  }

  set offset(offset) {
    _.merge(this._offset, offset);
  }

  get offset() {
    return {
      top: this._offset.top + (this.isPinnedTop ? 0 : (this._group.height - this.height)),
      left: this._offset.left + (this.isPinnedLeft ? 0 : (this._group.width - this.width)),
      right: this._offset.right - (this.isPinnedLeft ? (this._group.width - this.width) : 0),
      bottom: this._offset.bottom - (this.isPinnedTop ? (this._group.height - this.height) : 0),
    };
  }
}

/*
 <img onLoad={() => this.setItemLoaded()} className={'image' + (this.state.loaded ? '' : '-preload')}
 src={this.props.resized_url}/>
 */

export default ItemLayout;



// WEBPACK FOOTER //
// ./components/item/itemLayout.js